import { render, staticRenderFns } from "./SopDetailView.vue?vue&type=template&id=4dff7bcc&scoped=true&"
import script from "./SopDetailView.vue?vue&type=script&lang=ts&"
export * from "./SopDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff7bcc",
  null
  
)

export default component.exports